import styled from 'styled-components'

import { Container as Card } from '../../../components/Card/styles'

export const AvatarContainer = styled.div.attrs({
    className: 'animated zoomIn faster'
})`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
`

export const Container = styled.article`
	min-height: 80vh;
`